import React from 'react';
import styled from 'styled-components';
import { Icon } from 'components/common/Icon';
import { useNavigate } from 'react-router-dom';

export function SubTitle({ title, onBackCallback }) {
  const navigate = useNavigate();
  return (
    <TitleBox onClick={() => {
      if (onBackCallback) {
        onBackCallback()
      } else {
        navigate(-1);
      }
    }}>
      <Icon name="ArrowTail" />
      <H2>{title}</H2>
    </TitleBox>
  );
}

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 40px 16px 17px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.fill05};
`;

const H2 = styled.h2`
  display: block;
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.strong};
`;
